import {useEffect, useState} from 'react';

/** Use the bitmovin module after it has been dynamically imported */
export function useBitmovin(): typeof import('bitmovin-player') | undefined {
  const [api, setApi] = useState<typeof import('bitmovin-player')>();
  useEffect(() => {
    import('bitmovin-player').then((m) => setApi(m));
  }, []);
  return api;
}
